import {createApp} from "vue";
import App from "./App.vue";
import {store} from "./store";
import {Translations} from "@/types";
import {createPinia} from "pinia";
import {loadLayoutSections} from "@/store/catalog-store";

const appElement = document.querySelector<HTMLDivElement>("[data-store-catalog]");
if (appElement) {
    const translations = JSON.parse(appElement.dataset.translations ?? '{}') as Translations;
    const pinia = createPinia();
    loadLayoutSections();
    createApp(App, {translations: translations})
        .use(store)
        .use(pinia)
        .mount(appElement);
}
